export default "__VITE_ASSET__ClK8gOdw__"